import React from 'react';
import styled from 'styled-components';
import {
  datePropertyToDateString,
  // datePropertyToTimeString,
} from '../../../util';
import Node from './Node';
import { ILokalplan } from '../../../Interfaces/ILokalplan';

const HistoriskPlan = (props: IHistoriskPlanPropTypes) => {
  const {
    lokalplan,
    currentHistoriskeLokalplan,
    first,
    last,
    setCurrentHistoriskeLokalplan,
  } = props;

  // console.log({ historiskPlan, aktuelPlan });
  const renderSpans = () => {
    if (!lokalplan.feature.properties.aktuel) {
      if (isCurrent())
        return (
          <CurrentPlanLabel>
            {datePropertyToDateString(lokalplan.feature.properties.datoopdt)}
          </CurrentPlanLabel>
        );
      return (
        <PlanLabel>
          {datePropertyToDateString(lokalplan.feature.properties.datoopdt)}
        </PlanLabel>
      );
    }

    if (isCurrent()) return <CurrentPlanLabel>Gældende</CurrentPlanLabel>;
    return <PlanLabel>Gældende</PlanLabel>;
  };
  const isCurrent = () => {
    if (!currentHistoriskeLokalplan) return false;
    return (
      currentHistoriskeLokalplan.feature.properties.versionsnr ===
      lokalplan.feature.properties.versionsnr
    );
    // if (currentLokalplan.feature.properties.aktuel && !lokalplan) return true;
    // if (!lokalplan.feature.properties.aktuel) return false;
    // const currentProperties = currentLokalplan.feature.properties;
    // const lokalplanProperties = lokalplan.feature.properties;
    // if (currentProperties.datoopdt !== lokalplanProperties.datoopdt)
    //   return false;
    // return true;
  };

  return (
    <HistoriskLokalplan
      onClick={() => setCurrentHistoriskeLokalplan(lokalplan)}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {renderSpans()}
      </div>
      <Node first={first} last={last} isCurrent={isCurrent()} />
    </HistoriskLokalplan>
  );
};
const HistoriskLokalplan = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-evenly;
  height: 75px;
  margin-top: 15px;
  min-width: 130px;
  cursor: pointer;
`;

const PlanLabel = styled.span`
  border-radius: 3px;
  padding: 3px 5px;
`;
const CurrentPlanLabel = styled.span`
  color: #304255;
  background-color: #ede8e4;
  border-radius: 3px;
  padding: 3px 5px;
`;
interface IHistoriskPlanPropTypes {
  lokalplan?: ILokalplan;
  currentHistoriskeLokalplan: ILokalplan;
  setCurrentHistoriskeLokalplan?: Function;
  first: boolean;
  last: boolean;
}

export default HistoriskPlan;
